<div class="col-lg-11 tile-container gst-section mb3">
    <div *ngFor="let main_tile of data!.childContentList" 
        class="col-xs-12 col-md-6 col-lg-4 card solution_card">
        <div class="gst-card-header">
            <cbic-static-text class="Header" [textEn]="main_tile.titleEn" [textHi]="main_tile.titleHi"></cbic-static-text>
        </div>
        <div class="ellipsis custom-scroll-bar">
            <ul *ngIf="main_tile!.childContentList">
                <li *ngFor="let content of main_tile!.childContentList; index as inx">
                    <div *ngIf="!content.childContentCount">
                        <cbic-static-text
                            [textEn]="content.titleEn" 
                            [textHi]="content.titleHi"></cbic-static-text>
                        <span *ngFor = "let doc of content!.cbicDocMsts"  (click)="viewFile(doc.filePathEn)" class="pop-link">
                            <cbic-static-text *ngIf="doc.docTitleEn === content.titleEn || doc.docTitleHi === content.titleHi"
                            [textEn]="" [textHi]=""></cbic-static-text>
                            <span *ngIf="doc!.orderId??0 > 1">|</span>
                            <cbic-static-text *ngIf="doc.docTitleEn !== content.titleEn || doc.docTitleHi !== content.titleHi" 
                            [textEn]="doc.docTitleEn" [textHi]="doc.docTitleHi">
                            </cbic-static-text>
                            <i class="{{utils.getDocumentIcon(doc.docType)}}" aria-hidden="true"></i>
                        </span>
                    </div>
                    <cbic-link *ngIf="hasInfo(content) || content.childContentCount"
                        [linkTextEn]="content.titleEn"
                        [linkTextHi]="content.titleHi"
                        [linkEn]="content.path"
                        [linkHi]="content.path"></cbic-link>
                </li>
            </ul>
        </div>

    </div>
</div>